import { Component, OnInit, Input} from '@angular/core';
import { ItemService } from '../../../api/item.service'
import { ItemPaginate,Items } from '../../../class/itemclass'
import { DropDownClass } from '../../../class/dropdownclass'
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { HelperService,ErrorClass } from '../../../api/helper.service'
import { FileModal } from './file-modal.component'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class ItemComponent implements OnInit {

  public Editor = ClassicEditor;

  maxItemsPerPage = 10
  page = 1

  item_list:ItemPaginate = new ItemPaginate
  @Input() item:Items = new Items

  loading:boolean = false
  saving_item:boolean = false
  show_form:boolean = false

  item_category:DropDownClass[] = []
  item_target:DropDownClass[] = []
  need_type:DropDownClass[] = []
  is_active:DropDownClass[] = []

  
  constructor(
     private itemAPI:ItemService,
     private help:HelperService,
     private modal:NgbModal,
  ) { }

  ngOnInit() {
     this.setDefaultValue()
     this.loadDropdowns().then(
       () => {
        this.loadRecords(this.maxItemsPerPage,1)
       }
     )
  }

  setDefaultValue(){
    this.item.item_name = ''
    this.item.short_description = ''
    this.item.description = '<p>&nbsp;</p><p>&nbsp;</p>'
    this.item.hq_image = ''
    this.item.lq_image = ''
    this.item.minimum_amount = 0
    this.item.publish_date =  this.help.getCurDate()
    this.item.item_category = 1
    this.item.item_target = 1
    this.item.need_type = 1
    this.item.is_active = 1
    this.item.show_item =''
    this.item.motivation_code = 0;
    this.item.view_order = this.countData + 1;

  }

  async loadDropdowns(){
     this.itemAPI.getItemDropdowns().subscribe(async (data: any) => {
      this.item_category = data['item_category'];
      this.item_target = data['item_target'];
      this.need_type = data['need_type'];
      this.is_active = data['is_active'];
    }, (err: any) => {
      alert('Error Dropdowns' + JSON.stringify(err));
    })
  }

  countData:number = 1;
  loadRecords(maxItemsPerPage=10,page=1){
    this.loading = true
      this.itemAPI.getItems(maxItemsPerPage,page).subscribe(
        (data:ItemPaginate) => {
           this.item_list = data
           this.loading = false
           this.countData = this.item_list.data.length
        },
        (err) => {
          alert('Error:' + JSON.stringify(err))
          this.loading = false
        }
      )
  }

  //Create Records
  saveItem(){
    this.saving_item = true
     this.itemAPI.saveItems(this.item).subscribe(
       (data:any) => {
         const ld = () => this.loadRecords()
         this.help.msgbox("Item Saving","Successfully Record Saved").then(ld)
         this.saving_item = false
         this.show_form = false
         this.setDefaultValue()
       },
       (err:ErrorClass) => {
         this.help.msgboxError("Item Error",err.error_message)
         this.saving_item = false
       }
     )
  }

  editItem(r){
     this.item = r
     this.show_form = true
     window.scrollTo(0,0);
  }

  showForm(){
     this.show_form = true
     this.setDefaultValue()
  }
  cancel(){
    this.show_form = false
    this.setDefaultValue()
  }

   showFileModal(img){
    const modRef = this.modal.open(FileModal,{size:'lg'});
  
     modRef.result.then(
       (data) => {
        if(data){
          if(img=='hq'){
             this.item.hq_image = data
          }else if(img=='lq'){
            this.item.lq_image = data
          }else if(img =='sub_img1'){
            this.item.sub_img1 = data
          }
          else if(img =='sub_img2'){
            this.item.sub_img2 = data
          }
          else if(img =='sub_img3'){
            this.item.sub_img3 = data
          }
          else if(img =='sub_img4'){
            this.item.sub_img4 = data
          }
          else if(img =='sub_img5'){
            this.item.sub_img5 = data
          }
        }
      }
    )

  }

  //File Manager



}
